<p class="card-subtitle">
  paid information text
</p>